<template>
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="status">
        <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  data() {
    return {
      form: {
        status: 0,
      },
      loading: false,
    };
  },
  created() {
    /*获取设置*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    async getSetting() {
      try {
        const response = await AfuncApi.call({
          model: 'setting',
          action: 'get',
          setting_type: 'ma_position'  // 根据实际情况修改设置类型
        });
        
        if (response.code === 1 && response.data.values) {
          this.form = response.data.values;
        }
      } catch (error) {
        console.error('获取设置失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    /*点击保存*/
    async onSubmit() {
      try {
        this.loading = true;
        
        const response = await AfuncApi.call({
          model: 'setting',
          action: 'set',
          setting_type: 'ma_position',  // 根据实际情况修改设置类型
          ...this.form
        });
        
        if (response.code === 1) {
          this.$message.success('保存成功');
          // 重新获取设置以确保数据同步
          this.getSetting();
        } else {
          this.$message.error(response.msg || '保存失败');
        }
      } catch (error) {
        console.error('保存设置失败:', error);
        this.$message.error('保存失败');
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_position/setting/getSetting.vue